import { Link } from 'react-router-dom'
import PageHero from '../components/PageHero'
import PageCardImage from '../components/PageCardImage'
import { SOLUTIONS } from '../content/solutionsContent'
import { IMAGES } from '../content/images'

export default function SolutionsPage() {
  return (
    <div className="page">
      <PageHero
        title="Solutions"
        lead="Targeted pest management programs for commercial, industrial, and regulated environments."
        image={IMAGES.solutions}
        imageAlt="Commercial pest management solutions"
        imagePosition="center 30%"
      />

      <section className="page-section">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="page-grid page-grid--2">
            {SOLUTIONS.map((solution) => (
              <article key={solution.slug} className="page-card page-card--link page-card--media">
                <PageCardImage src={solution.image} alt={solution.title} />
                <h2 className="page-card__title">
                  <Link to={`/solutions/${solution.slug}`}>{solution.title}</Link>
                </h2>
                <p className="page-card__text">{solution.shortDescription}</p>
                <Link to={`/solutions/${solution.slug}`} className="page-card__cta">
                  View program details <span aria-hidden="true">&gt;</span>
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}
